import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";

export const getCourseQuizeApi = createAsyncThunk("quize/getByCourseId", async (courseId) => {
  try {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
    return await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/quize/getQuzeByCourseId/${courseId}`,{
        method: "GET",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
      }
    ).then((res) => res.json());
  } catch (error) {
    swal("Error", error, "info");
    return error;
  }
});

const getQuizeByCourseIdSlicer = createSlice({
  name: "get Quize By Course Id",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getCourseQuizeApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCourseQuizeApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
    builder.addCase(getCourseQuizeApi.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "Quize fetched Successfully") {
        state.data = action.payload;
      } else {
        state.error = action.payload.message;
      }
    });
  },
});

export default getQuizeByCourseIdSlicer.reducer;
